import { AppContext } from "@Context/common/general/context";
import PhaseOfPlay from "@Enums/PhaseOfPlay";
import PhaseOfPlayMap from "@Enums/PhaseOfPlayMap";
import getDeterministicColor from "@Helpers/get-deterministic-color";
import { Chip, Stack, Typography } from "@mui/material";
import { ScenarioResponse } from "@Shared/schemas/scenarios/scenarioSchemas";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useContext, useState } from "react";
import { BybListItem, ListItemCell } from "../common";
import { getPlayPositionString } from "./helpers";
import ScenarioDialogWrapper from "./scenario-dialog-wrapper";

dayjs.extend(relativeTime);

/**
 * This component is part of the VR app V2 redesign
 */

interface IScenarioListItem {
  scenario: ScenarioResponse;
  scenarioEditorData: any;
  onUpdate: () => void;
  onDelete: () => void;
}

const ScenarioListItem = ({ scenario, scenarioEditorData, onUpdate, onDelete }: IScenarioListItem) => {
  const scenarioState = scenario.published ? "published" : "draft";
  const { state, dispatch } = useContext(AppContext);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <BybListItem columns={6} onClick={() => setModalOpen(true)}>
        <ListItemCell first colSpan={2} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          <Stack spacing={0.5}>
            <Typography variant="textLg700" color="dsBase.v200">
              {scenario.name}
            </Typography>
            <Stack direction="row" spacing={1}>
              <Typography variant="textBase500" color="dsNeutral.v400" sx={{ textTransform: "capitalize" }}>
                {state.user.id === scenario.created_by_doc_id ? "You" : `${scenario.created_by_first_name} ${scenario.created_by_last_name}`}
              </Typography>
              <Typography variant="textBase500" color="dsNeutral.v400">
                {`•`}
              </Typography>
              <Typography variant="textBase500" color="dsNeutral.v400">
                {dayjs(scenario.created_at).fromNow()}
              </Typography>
            </Stack>
          </Stack>
        </ListItemCell>
        <ListItemCell>
          <Stack direction="row" spacing={1}>
            {scenario.tags?.map((tag, index) => (
              <Chip size="small" color="info" sx={{ color: "black", fontWeight: "600", backgroundColor: getDeterministicColor(tag) }} label={tag} />
            ))}
          </Stack>
        </ListItemCell>
        <ListItemCell>{PhaseOfPlayMap[scenario.phase_of_play as PhaseOfPlay]}</ListItemCell>
        <ListItemCell>{getPlayPositionString(scenario.play_positions)}</ListItemCell>
        {/* <ListItemCell>{DifficultyMap[scenario.difficulty as Difficulties]}</ListItemCell> */}
        <ListItemCell sx={{ justifySelf: "end" }}>
          <Chip size="small" color={scenarioState === "published" ? "success" : "warning"} label={scenarioState} />
        </ListItemCell>
      </BybListItem>

      {/* Scenario dialog */}
      <ScenarioDialogWrapper
        open={modalOpen}
        scenario={scenario}
        scenarioEditorData={scenarioEditorData}
        onClose={() => setModalOpen(false)}
        onUpdate={onUpdate}
        onDelete={onDelete}
      />
    </>
  );
};

export default ScenarioListItem;
